

























































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import {
  GQL_UnitPaycheckSettingsAltinn3SystemUserStatusEnum,
} from '@/queries/global';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_getAltinn3SystemUserStatus } from '@/queries/__generated__/getAltinn3SystemUserStatus';
import { GQL_registerAltinn3SystemUser } from '@/queries/__generated__/registerAltinn3SystemUser';
import { GQL_altinn3SystemUserConfirmationUrl } from '@/queries/__generated__/altinn3SystemUserConfirmationUrl';
import { GQL_refreshAltinn3SystemUserStatus } from '@/queries/__generated__/refreshAltinn3SystemUserStatus';

const GET_ONGOING_CONFIRMATION_LINK = gql`
  query altinn3SystemUserConfirmationUrl {
    altinn3SystemUserConfirmationUrl
  }
`;

const REGISTER_USER = gql`
  mutation registerAltinn3SystemUser($withDeleteRequest: Boolean!) {
    registerAltinn3SystemUser(input: {withDeleteRequest: $withDeleteRequest}) {
      confirmationUrl
    }
  }
`;

const REFRESH_STATUS = gql`
  mutation refreshAltinn3SystemUserStatus {
    refreshAltinn3SystemUserStatus(input: {}) {
      unitPaycheckSetting {
        id
        altinn3SystemUserStatus
      }
    }
  }
`;

const GET_ALTINN3_SYSTEM_USER_STATUS = gql`
  query getAltinn3SystemUserStatus {
    currentUnit {
      id
      unitSetting {
        id
        unitPaycheckSetting {
          id
          altinn3SystemUserStatus
        }
      }
    }
  }
`;

@Component
export default class Altinn3SystemUserForm extends Vue {
  @SmartQuery<Altinn3SystemUserForm, GQL_getAltinn3SystemUserStatus>({
    query: GET_ALTINN3_SYSTEM_USER_STATUS,
    update: data => data.currentUnit.unitSetting.unitPaycheckSetting.altinn3SystemUserStatus,
  }) private currentStatus?: GQL_UnitPaycheckSettingsAltinn3SystemUserStatusEnum;

  private working = false;

  private mounted() {
    if (this.$route.query['refresh-altinn3-system-user']) {
      this.refreshStatus();
    }
  }

  private registerSystemUser(withDeleteRequest = false) {
    this.working = true;

    this.$apollo.mutate<GQL_registerAltinn3SystemUser>({
      mutation: REGISTER_USER,
      variables: {withDeleteRequest},
    })
      .then(({ data }) => {
        const confirmationUrl = data?.registerAltinn3SystemUser?.confirmationUrl;

        if (confirmationUrl) {
          window.open(confirmationUrl, '_blank');
        }
      })
      .finally(() => {
        this.working = false;
      });
  }

  private continueRegisteringSystemUser() {
    this.working = true;

    this.$apollo.query<GQL_altinn3SystemUserConfirmationUrl>({
      query: GET_ONGOING_CONFIRMATION_LINK,
    })
      .then(({ data }) => {
        const confirmationUrl = data?.altinn3SystemUserConfirmationUrl;

        if (confirmationUrl) {
          window.open(confirmationUrl, '_blank');
        }
      })
      .finally(() => {
        this.working = false;
      });
  }

  private refreshStatus() {
    this.working = true;

    this.$apollo.mutate<GQL_refreshAltinn3SystemUserStatus>({
      mutation: REFRESH_STATUS,
    })
      .then(() => {
        // nothing to do. updating the apollo cache fixes the currentStatus
      })
      .finally(() => {
        this.working = false;
      });
  }
}
